import { createFileRoute } from '@tanstack/react-router';
import { EmployeeRegisterTable } from '@/components/company/employees/table/employee-table';

export const Route = createFileRoute('/(app)/company/employees/')({
  component: CompanyEmployeesRoute,
});

function CompanyEmployeesRoute() {
  return (
    <EmployeeRegisterTable />
  );
}
